import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CommonMethodsHelper  {
    _originalTypeClassName = "zERP.BO.CommonMethodsHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CommonMethodsHelper.translate = translateService;
}
this.CommonMethodsHelperKey = null;
this._key = this.CommonMethodsHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _CommonMethodsHelperKey:any;
get CommonMethodsHelperKey(): any {
    return this._CommonMethodsHelperKey;
  }
set CommonMethodsHelperKey(value: any) {
    this._CommonMethodsHelperKey = value;
    this._key = value;
  }

static AddLeadingZeros(number: any,length: any): any{let numberString = number?.toString();
let numberLength = numberString?.length;
if (CLMS.Framework.Number.GreaterThanOrEqual(() => numberLength, () => length)) {return numberString;}
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => Joove.Common.safeNumber(length) - Joove.Common.safeNumber(numberLength)); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
numberString = "0" + numberString;}

return numberString;
}
static AmountsAreEqual(amount1: any,amount2: any,precision: any): any{if (CLMS.Framework.Number.Equal(() => precision, () => null) || CLMS.Framework.Number.LessThanOrEqual(() => precision, () => 0)) {precision = 3;}
let tollerance = Joove.Common.cast(Math.pow(10, (Joove.Common.safeNumber(0) - Joove.Common.safeNumber(precision))), "number");
return CLMS.Framework.Number.LessThanOrEqual(() => Math.abs(Joove.Common.safeNumber(amount1) - Joove.Common.safeNumber(amount2)), () => tollerance);
}
static GetFileNamesHash(files: any): any{if (files == null || CLMS.Framework.Number.LessThanOrEqual(() => files.length, () => 0)) {return "";}
let fileNames = CLMS.Framework.String.Join(",", files?.linq?.select((d) => d?.FileName)?.toArray());
return fileNames;
}
static MyDataEnumValueToInt(enumValue: any,replaceStr: any): any{if (replaceStr == null) {replaceStr = "Item_";}
return CLMS.Framework.Integer.Parse(Joove.Common.replaceAll(enumValue?.toString(), replaceStr, ""));
}
static RoundUpToStep(value: any,step: any,roundingMethod: any): any{if (roundingMethod == Domain.RoundingMethod.Ceil) {return Joove.Common.safeNumber(Math.ceil(Joove.Common.safeNumber(value) / Joove.Common.safeNumber(step))) * Joove.Common.safeNumber(step);}else if (roundingMethod == Domain.RoundingMethod.Floor) {return Joove.Common.safeNumber(Math.floor(Joove.Common.safeNumber(value) / Joove.Common.safeNumber(step))) * Joove.Common.safeNumber(step);}
let ceil = Joove.Common.safeNumber(Math.ceil(Joove.Common.safeNumber(value) / Joove.Common.safeNumber(step))) * Joove.Common.safeNumber(step);
let floor = Joove.Common.safeNumber(Math.floor(Joove.Common.safeNumber(value) / Joove.Common.safeNumber(step))) * Joove.Common.safeNumber(step);
return ((CLMS.Framework.Number.GreaterThan(() => Math.abs(Joove.Common.safeNumber(value) - Joove.Common.safeNumber(ceil)), () => Math.abs(Joove.Common.safeNumber(value) - Joove.Common.safeNumber(floor)))) ? floor : ceil);
}
static TrimTrailingZeroes(text: any): any{if (CLMS.Framework.String.IsNullOrEmpty((text ?? '').trim())) {return text;}
text = text?.trim();
if (CLMS.Framework.Number.NotEqual(() => text.indexOf("0"), () => 0)) {return text;}
while (true) {if (CLMS.Framework.Number.Equal(() => text.indexOf("0"), () => 0)) {text = text?.substr(1);continue;}return text;}
return text;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CommonMethodsHelperKey == null || $this.CommonMethodsHelperKey == 0;
            }


}